import React, { useState, useEffect } from 'react';
import {
  Col, Form, InputGroup, Row, Table,
} from 'react-bootstrap';
import axios from 'axios';
import { Content } from '../style';
import searchLogo from './logo/searchLogo.png';
import config from '../../../../config';
import CardsStatus from './CardStatus';
import ListKum from './ListKum';

const Section = () => {
  const [state, setState] = useState({
    npmTarget: '',
  });
  const [dataMahasiswa, setDataMahasiswa] = useState([]);
  const [dataKum, setDataKum] = useState([]);
  const [status, setStatus] = useState('');

  const inputChange = (e, input) => {
    const ubah = e.target.value;
    setState({
      ...state,
      [input]: ubah,
    });
  };

  useEffect(() => {
    if (dataMahasiswa.length !== 0) {
      if (dataMahasiswa.prodi.includes('Double Degree')) {
        if ((dataMahasiswa.angkatan === '2017') && (parseFloat(dataMahasiswa.total_bobot) >= 2)) {
          setStatus('Terpenuhi');
        } else if ((dataMahasiswa.angkatan === '2018') && (parseFloat(dataMahasiswa.total_bobot) >= 3)) {
          setStatus('Terpenuhi');
        } else if (parseFloat(dataMahasiswa.total_bobot) >= 4) {
          setStatus('Terpenuhi');
        } else {
          setStatus('Belum Terpenuhi');
        }
      } else if ((dataMahasiswa.angkatan === '2017') && (parseFloat(dataMahasiswa.total_bobot) >= 4)) {
        setStatus('Terpenuhi');
      } else if ((dataMahasiswa.angkatan === '2018') && (parseFloat(dataMahasiswa.total_bobot) >= 6)) {
        setStatus('Terpenuhi');
      } else if (parseFloat(dataMahasiswa.total_bobot) >= 8) {
        setStatus('Terpenuhi');
      } else {
        setStatus('Belum Terpenuhi');
      }
    }
  }, [dataMahasiswa]);

  useEffect(() => {
    setStatus('');
    if (state.npmTarget.length === 10) {
      setDataMahasiswa([]);
      setDataKum([]);
      axios.get(`${config.API_BASE_URL}api/account/get-mahasiswa/${state.npmTarget}`, {
        headers: {
          accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }).then((info) => {
        setDataMahasiswa(
          info.data,
        );
      });

      axios.get(`${config.API_BASE_URL}api/partisipasi_kuliah_umum/?status=disetujui&npm=${state.npmTarget}`, {
        headers: {
          accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }).then((info) => {
        setDataKum(
          info.data,
        );
      });
    }
  }, [state.npmTarget]);

  return (
    <Content>
      <Form.Row>
        <Form.Group as={Col}>
          <h1 className="mb-4">Pemeriksaan Partisipasi KUM Mahasiswa</h1>
          <InputGroup className="searchBar">
            <InputGroup.Prepend>
              <InputGroup.Text className="logo" data-testid="logo">
                <img src={searchLogo} alt="searchLogo" className="searchLogo" />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              className="searchBar"
              data-testid="inputNPM"
              type="text"
              placeholder="Input NPM di sini.."
              onChange={(e) => { inputChange(e, 'npmTarget'); }}
              value={state.npmTarget}
            />
          </InputGroup>
        </Form.Group>
      </Form.Row>
      {status !== ''
        && (
          <Row>
            <CardsStatus
              nama={dataMahasiswa.user.name}
              bobot={dataMahasiswa.total_bobot}
              partisipasi={dataKum.length}
              status={status}
            />
            <div className="listKum">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Nomor</th>
                    <th>Nama Kuliah Umum</th>
                    <th>Tanggal</th>
                    <th>Nilai Kum</th>
                  </tr>
                </thead>
                <tbody>
                  {dataKum.map((
                    (data, index) => (
                      <ListKum
                        number={index + 1}
                        nama={data.kum.nama_kegiatan}
                        tanggal={data.kum.tanggal}
                        nilaiKum={data.kum.nilai_kum}
                      />
                    )
                  ))}
                </tbody>
              </Table>
            </div>
          </Row>
        )}
    </Content>
  );
};

export default Section;
